<script lang="ts" setup>
import { ref } from "vue"
import { KirbyBlock } from "@/queries/blocks"

export interface KirbyBlock_SketchFab extends KirbyBlock {
  content: {
    url: string
  }
}

const props = defineProps<{
  block: KirbyBlock_SketchFab
}>()

defineEmits<{
  open: []
}>()

const thumbnailUrl = ref<string | null>(null)

const res = await fetch(
  `https://sketchfab.com/oembed?url=${props.block.content.url}`,
).catch(() => null)

if (res?.ok) {
  const data = await res.json().catch(() => null)
  if (data?.thumbnail_url) thumbnailUrl.value = data.thumbnail_url
}
</script>

<template>
  <div
    :id="block.id"
    class="relative w-full h-full overflow-hidden aspect-video cursor-pointer"
    @click="$emit('open')"
  >
    <div class="flex items-center justify-center w-full h-full">
      <img
        v-if="thumbnailUrl"
        :src="thumbnailUrl"
        alt="Sketchfab thumbnail"
        class="object-contain"
      />
      <div class="absolute inset-0 flex items-center justify-center text-white">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="white"
          class="w-20 h-20 drop-shadow-lg"
        >
          <path
            d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
          />
        </svg>
      </div>
    </div>
  </div>
</template>
